var styles = {"box":"ContentCollection_box_19nw2_1","title":"ContentCollection_title_19nw2_1","expand":"ContentCollection_expand_19nw2_11","list":"ContentCollection_list_19nw2_14"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
